var _circle, _circle2, _circle3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDialogSetPoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1875 49.853C64.8906 52.3237 62.3125 56.8354 62.3125 61.6694C62.3125 66.6108 64.8906 71.1226 69.1875 73.5933C73.377 76.064 78.6406 76.064 82.9375 73.5933C87.127 71.1226 89.8125 66.6108 89.8125 61.6694C89.8125 56.8354 87.127 52.3237 82.9375 49.853C78.6406 47.3823 73.377 47.3823 69.1875 49.853ZM71.1211 80.5757C60.4863 80.5757 52 89.1694 52 99.8042C52 101.523 53.3965 102.919 55.1152 102.919H81.0467C80.3716 101.245 80 99.416 80 97.5C80 90.7019 84.6782 84.9965 90.9909 83.4275C88.0585 81.6186 84.6013 80.5757 80.8965 80.5757H71.1211Z",
    fill: "url(#paint0_linear_6508_152918)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.752 104.5C87.0879 108.562 91.3535 111 96.0254 111C100.646 111 104.912 108.562 107.248 104.5C109.584 100.488 109.584 95.5625 107.248 91.5C104.912 87.4883 100.646 85 96.0254 85C91.3535 85 87.0879 87.4883 84.752 91.5C82.416 95.5625 82.416 100.488 84.752 104.5ZM104.609 94.2207C105.13 93.734 105.13 92.8822 104.609 92.3955C104.127 91.8682 103.284 91.8682 102.803 92.3955L93.4515 101.846L89.1973 97.5874C88.7157 97.0601 87.8729 97.0601 87.3913 97.5874C86.8696 98.0741 86.8696 98.9259 87.3913 99.4126L92.5284 104.605C93.01 105.132 93.8528 105.132 94.3344 104.605L104.609 94.2207Z",
    fill: "url(#paint1_linear_6508_152918)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6508_152918",
    x1: 86.375,
    y1: 48.0444,
    x2: 86.375,
    y2: 103.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6508_152918",
    x1: 96.0254,
    y1: 85.0591,
    x2: 96.0254,
    y2: 111.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDialogSetPoa);
export default __webpack_public_path__ + "static/media/img_dialog_set_poa.4d70c428bf48c5e3c2a5caaa03c39c8b.svg";
export { ForwardRef as ReactComponent };